import { QuestionTypeEnum } from './question-type-enum'

export interface PaperQuestionReqInterface {
  treeNodeId?: number
  treeNodePid?: number
  /**
   * 父ID
   */
  parentId?: number
  /**
   * 题目类型
   */
  type: QuestionTypeEnum
  /**
   * 是否是小题，1是，0不是
   */
  isQuestion?: number
  /**
   * 题干富文本
   */
  stem?: string | null
  /**
   * 选项
   */
  options?: string[]
  /**
   * 标准答案
   */
  standardAnswers?: string[]
  /**
   * 解析
   */
  analysis?: string | null
  score?: string | null
  /**
   * 题目额外设置
   */
  settings?: object | null
  isPublished?: boolean
  /**
   * 题目排序值
   */
  weight?: number
}

export class PaperQuestionReq implements PaperQuestionReqInterface {
  treeNodeId?: number
  treeNodePid?: number
  /**
   * 父ID
   */
  parentId?: number
  /**
   * 题目类型
   */
  type: QuestionTypeEnum
  /**
   * 是否是小题，1是，0不是
   */
  isQuestion?: number
  /**
   * 题干富文本
   */
  stem?: string | null
  /**
   * 选项
   */
  options?: string[]
  /**
   * 标准答案
   */
  standardAnswers?: string[]
  /**
   * 解析
   */
  analysis?: string | null
  score?: string | null
  /**
   * 题目额外设置
   */
  settings?: object | null
  isPublished?: boolean
  /**
   * 题目排序值
   */
  weight?: number

  constructor(props: PaperQuestionReqInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      treeNodeId: _treeNodeId,
      treeNodePid: _treeNodePid,
      parentId: _parentId,
      type: _type,
      isQuestion: _isQuestion,
      stem: _stem,
      options: _options,
      standardAnswers: _standardAnswers,
      analysis: _analysis,
      score: _score,
      settings: _settings,
      isPublished: _isPublished,
      weight: _weight,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.treeNodeId = _treeNodeId
    this.treeNodePid = _treeNodePid
    this.parentId = _parentId
    this.type = _type
    this.isQuestion = _isQuestion
    this.stem = _stem
    this.options = _options
    this.standardAnswers = _standardAnswers
    this.analysis = _analysis
    this.score = _score
    this.settings = _settings
    this.isPublished = _isPublished
    this.weight = _weight
  }
}
